// @flow

import * as React from 'react';

import FirstLoadController from '../../components/FirstLoadController';
import Invoices from './Invoices';

type Props = {
  active: boolean,
};

export default function(props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <Invoices {...props} />
    </FirstLoadController>
  );
}
